//libs
import React, {Component} from 'react';
import {connect} from 'react-redux';
//helpoars,config,actions
import {show} from '../../actions/sidebar';
import {isAdmin} from '../../helpers';

class View extends Component {


    menuItemClick(event){
        if (window.innerWidth<1024){
            const {dispatch} = this.props;
            dispatch(show());
        }
    }

    render() {

        let x= null;
        let menu = [
            {
                'id':'start',
                'url':'/#/',
                'title':'Start',
                'isActive':false,
                'isEnabled':false
            },
            {
                'id':'orders',
                'url':'/#/Orders',
                'title':'Beställningar',
                'isActive':false,
                'isEnabled':true
            },
            {
                'id':'stock',
                'url':'/#/Stock',
                'title':'Lager',
                'isActive':false,
                'isEnabled':true
            },
            {
                'id':'outgoing',
                'url':'/#/Outgoing',
                'title':'Utgående',
                'isActive':false,
                'isEnabled':true
            },
            {
                'id':'users',
                'url':'/#/UsersGroups',
                'title':'Användare & grupper',
                'isActive':false,
                'isEnabled': isAdmin()
            },
            {
                'id':'search',
                'url':'/#/Search',
                'title':'Sök hjulset',
                'isActive':false,
                'isEnabled':true
            },
            {
                'id':'reports',
                'url':'/#/Reports',
                'title':'Rapporter',
                'isActive':false,
                'isEnabled':isAdmin()
            }
        ];


        if (this.props.location){
          for(x in menu) {
            menu[x].isActive = "/#"+this.props.location.pathname===menu[x].url;
          }
        }

       return (
            <div id="menu" className="menu">
                <ul>
                    {menu.map(mi =>{
                        if (mi.isEnabled){
                            return (
                                <li key={mi.id} className={mi.isActive ? mi.id+" active": mi.id}>
                                    <a onClick={(event)=>this.menuItemClick()}href={mi.url}>
                                        <span>{mi.title}</span>
                                    </a>
                                </li>)
                        } else {
                            return null;
                        }
                    })}
                </ul>
            </div>
        );
    }

}

/**
 * Map actions to properties
 */
const mapStateToProps = (state) => ({
    isOpen: state.sidebar.isOpen
});

export default connect(mapStateToProps)(View)



// WEBPACK FOOTER //
// ./src/components/Menu/View.js